module.exports = __webpack_public_path__ + "img/avatar-57.9bfc9885.png";